import React, { useState } from 'react';
import { useUser } from '../../context/UserContext';
interface BirthDetailsFormProps {
  onContinue: () => void;
}
const BirthDetailsForm: React.FC<BirthDetailsFormProps> = ({
  onContinue
}) => {
  const {
    updateUserData,
    userData
  } = useUser();
  const [name, setName] = useState(userData.name || '');
  const [email, setEmail] = useState(userData.email || '');
  const [emailError, setEmailError] = useState('');
  const [birthDate, setBirthDate] = useState(userData.birthDate || '');
  const [birthTime, setBirthTime] = useState(userData.birthTime || '');
  const [birthLocation, setBirthLocation] = useState(userData.birthLocation || '');
  const [formSubmitted, setFormSubmitted] = useState(false);
  const validateEmail = (email: string): boolean => {
    const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return re.test(email);
  };
  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newEmail = e.target.value;
    setEmail(newEmail);
    if (newEmail && !validateEmail(newEmail)) {
      setEmailError('Please enter a valid email address');
    } else {
      setEmailError('');
    }
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setFormSubmitted(true);
    if (email && !validateEmail(email)) {
      setEmailError('Please enter a valid email address');
      return;
    }
    try {
      updateUserData({
        name,
        email,
        birthDate,
        birthTime,
        birthLocation
      });
      onContinue();
    } catch (error) {
      console.error('Error updating user data:', error);
      // You could add UI feedback here for the error case
    }
  };
  return <div data-id="element-302">
      <h2 className="text-2xl font-bold mb-6 text-center text-green-700" data-id="element-303">
        Tell Us About Yourself
      </h2>
      <form onSubmit={handleSubmit} noValidate data-id="element-304">
        <div className="mb-4" data-id="element-305">
          <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-306">
            Your Name
          </label>
          <input type="text" id="name" value={name} onChange={e => setName(e.target.value)} className={`w-full p-3 border rounded-lg focus:ring-green-500 focus:border-green-500 ${formSubmitted && !name ? 'border-red-300' : 'border-gray-300'}`} required data-id="element-307" />
          {formSubmitted && !name && <p className="mt-1 text-sm text-red-600" data-id="element-308">Name is required</p>}
        </div>
        <div className="mb-4" data-id="element-309">
          <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-310">
            Email Address
          </label>
          <input type="email" id="email" value={email} onChange={handleEmailChange} className={`w-full p-3 border rounded-lg focus:ring-green-500 focus:border-green-500 ${emailError ? 'border-red-300' : 'border-gray-300'}`} placeholder="your@email.com" required data-id="element-311" />
          {emailError && <p className="mt-1 text-sm text-red-600" data-id="element-312">{emailError}</p>}
          <p className="mt-1 text-xs text-gray-500" data-id="element-313">
            We'll use this to save your progress and allow you to log back in
            later.
          </p>
        </div>
        <div className="mb-4" data-id="element-314">
          <label htmlFor="birthDate" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-315">
            Birth Date
          </label>
          <input type="date" id="birthDate" value={birthDate} onChange={e => setBirthDate(e.target.value)} className={`w-full p-3 border rounded-lg focus:ring-green-500 focus:border-green-500 ${formSubmitted && !birthDate ? 'border-red-300' : 'border-gray-300'}`} required data-id="element-316" />
          {formSubmitted && !birthDate && <p className="mt-1 text-sm text-red-600" data-id="element-317">Birth date is required</p>}
        </div>
        <div className="mb-4" data-id="element-318">
          <label htmlFor="birthTime" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-319">
            Birth Time (approximate)
          </label>
          <input type="time" id="birthTime" value={birthTime} onChange={e => setBirthTime(e.target.value)} className={`w-full p-3 border rounded-lg focus:ring-green-500 focus:border-green-500 ${formSubmitted && !birthTime ? 'border-red-300' : 'border-gray-300'}`} required data-id="element-320" />
          {formSubmitted && !birthTime && <p className="mt-1 text-sm text-red-600" data-id="element-321">Birth time is required</p>}
        </div>
        <div className="mb-6" data-id="element-322">
          <label htmlFor="birthLocation" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-323">
            Birth Location
          </label>
          <input type="text" id="birthLocation" value={birthLocation} onChange={e => setBirthLocation(e.target.value)} placeholder="City, Country" className={`w-full p-3 border rounded-lg focus:ring-green-500 focus:border-green-500 ${formSubmitted && !birthLocation ? 'border-red-300' : 'border-gray-300'}`} required data-id="element-324" />
          {formSubmitted && !birthLocation && <p className="mt-1 text-sm text-red-600" data-id="element-325">
              Birth location is required
            </p>}
        </div>
        <button type="submit" className="bg-green-600 text-white py-3 px-6 rounded-lg shadow-md hover:bg-green-700 transition-colors w-full font-medium" data-id="element-326">
          Continue
        </button>
      </form>
    </div>;
};
export default BirthDetailsForm;